/**
 * Domyślny model pod `MODEL_NAME`. Pozostałe wpisy — ta sama tablica co poniżej (tylko w komentarzu);
 * podmień `MODEL_NAME` na wybrany `model_id`, żeby przełączyć backend (`generate-workout`).
 *
 * ```json
 * {
 *   "workout_generator_models": [
 *     {
 *       "model_id": "gemini-3.1-flash-lite",
 *       "suitability_for_json": "Bardzo Wysoka",
 *       "latency": "Błyskawiczna",
 *       "rpd_limit": 500,
 *       "verdict": "Najlepszy wybór na start. Idealny balans między mądrością a wydajnością.",
 *       "recommended_use_case": "Standardowe generowanie treningów dla wszystkich użytkowników."
 *     },
 *     {
 *       "model_id": "gemini-3-flash",
 *       "suitability_for_json": "Doskonała",
 *       "latency": "Bardzo Szybka",
 *       "rpd_limit": 20,
 *       "verdict": "Tylko do testów „trudnych” przypadków lub dla kont PRO.",
 *       "recommended_use_case": "Złożone treningi z wielopoziomowymi powtórzeniami."
 *     },
 *     {
 *       "model_id": "gemma-4-31b",
 *       "suitability_for_json": "Wysoka",
 *       "latency": "Szybka",
 *       "rpd_limit": 1500,
 *       "verdict": "Backup „ratunkowy”, gdy skończą się limity głównego Gemini.",
 *       "recommended_use_case": "Proste formatowanie danych i kategoryzacja przy dużym ruchu."
 *     },
 *     {
 *       "model_id": "gemini-3.1-pro",
 *       "suitability_for_json": "Najwyższa",
 *       "latency": "Średnia",
 *       "rpd_limit": 0,
 *       "verdict": "Wymaga planu płatnego. Do analizy całych tygodni treningowych.",
 *       "recommended_use_case": "Personalizacja planów długoterminowych i analiza biomechaniczna."
 *     },
 *     {
 *       "model_id": "gemini-1.5-flash",
 *       "suitability_for_json": "Stabilna",
 *       "latency": "Szybka",
 *       "rpd_limit": "Zależne od Tieru",
 *       "verdict": "Solidna alternatywa, jeśli wersje 3.x miałyby błędy.",
 *       "recommended_use_case": "Fallback w przypadku problemów z najnowszymi wersjami modeli."
 *     }
 *   ]
 * }
 * ```
 */
export const GEMINI_CONFIG = {
  /** Zgodny z pierwszym modelem w `MODEL_CHAIN` (free tier AI Studio). */
  MODEL_NAME: 'gemini-2.5-flash',
  DEFAULT_BIKE_EXAMPLE_PROMPT: '90 min bike workout: 10 min warmup, 3x10 min tempo with 5 min recovery, 10 min cooldown',
  DEFAULT_BIKE_EXAMPLE_PROMPT_PL:
    '90 min trening rowerowy: 10 min rozgrzewka, 3x10 min na progu z 5 min odpoczynku, 10 min schłodzenie',
  DEFAULT_RUN_EXAMPLE_PROMPT: '45 min run: 10 min warm up, 5x 1km @ Threshold Pace, cool down',
  DEFAULT_RUN_EXAMPLE_PROMPT_PL: '45 min bieg: 10 min rozgrzewki, 5x 1km w Tempie Progowym, schłodzenie',
  GUEST_GENERATION_LIMIT: 2,
} as const;
